export default "__VITE_ASSET__DHxNMUga__"